module.exports = __webpack_public_path__ + "static/media/token.8447a8ea.svg";